<script>
  import News from '@components/List/News'
  import Bulletin from '@components/List/Bulletin'

  export default {
    components: {
      News,
      Bulletin,
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    computed: {
      formattedTopList() {
        return this.list.map((item) => ({
          title: item.title,
          publish_up: item.publish_up,
          description: item.description,
          introtext: item.introtext,
          brands: item.brands[0],
          introimage: item.introimage,
          extrafields: item.extrafields,
          to: {
            name: 'news-item',
            params: {
              brandAlias: this.$route.query.brand || item.brands[0] && item.brands[0].alias,
              categoryAlias: item.category_alias.split('/')[1],
              newsAlias: item.alias,
            },
          },
          isdealer: item.extrafields.dealer_only.value === "1"
        }))
      },
    },
    methods: {
      goToView(val) {
        this.$emit('goTo', val)
      }
    }
  }
</script>
<template>
  <div :class="$style.SectionRowItem" class="section">
    <div class="container">
      <Bulletin
        v-if="$route.params.categoryAlias === 'bulletin'"
        is-row-item
        :list="formattedTopList"
        content-type="news"
        @goTo="goToView"
      />
      <News
        v-else
        is-row-item
        :list="formattedTopList"
        content-type="news"
        @goTo="goToView"
      />
    </div>
  </div>
</template>
<style lang="scss" module>
  .SectionRowItem {
    background-color: $color-gray-2;
  }
</style>
